import { render } from "./AppointmentViewModal.vue?vue&type=template&id=1f50772e&scoped=true"
import script from "./AppointmentViewModal.vue?vue&type=script&lang=js"
export * from "./AppointmentViewModal.vue?vue&type=script&lang=js"

import "./AppointmentViewModal.vue?vue&type=style&index=0&id=1f50772e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f50772e"]])

export default __exports__